<template>
  <div style="height: 100%">
    <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
      <template slot="lastHeaderColumns" slot-scope="props">
        <grid-table-th
          v-if="props.magicalMenuCodes.includes('push-content')"
          width="80px"
        >操作
        </grid-table-th>
        <grid-table-th
          v-if="props.magicalMenuCodes.includes('push-content')"
          width="80px"
        >推送内容
      </grid-table-th>
    </template>
    <template slot="lastBodyColumns" slot-scope="props">
      <grid-table-td
        v-if="props.magicalMenuCodes.includes('push-content') && (props.row.sendState === '发送失败')"
        @click.native="operation(props.row)"
        width="80px"
      >查看详情
      </grid-table-td>
      <grid-table-td
        v-else
        @click.native="operation(props.row)"
        width="80px"
      >更新
      </grid-table-td>
      <grid-table-td
        v-if="props.magicalMenuCodes.includes('push-content')"
        @click.native="handle(props.row)"
        width="80px"
      >查看
      </grid-table-td>
    </template>
    </grid>
    <whaty-dialog
      :title="detailTitle"
      :visible.sync="dialogVisible"
      width="400px"
      top="32vh">
      <div class="popup-wrap" slot="body">
        <div class="popup-body">
          <div class="el-dialog__body whaty-dialog-content">
            <span v-html="content"></span>
          </div>
          <div class="popup-foot group" style="padding-right: 0;">
            <a href="javascript:" class="btn btn-solid-primary" @click="dialogVisible = false">确定</a>
          </div>
        </div>
      </div>
    </whaty-dialog>
  </div>
</template>

<script>
import Grid from '../../../../components/grid/grid'
import GridTableTh from '../../../../components/grid-menu/grid-table-th'
import GridTableTd from '../../../../components/grid-menu/grid-table-td'
import GridTopMenu from '../../../../components/grid-menu/grid-top-menu'
import WhatyDialog from '../../../../components/dialog/dialog'
import util from '../../../../libs/util'

export default {
  components: {
    GridTopMenu,
    GridTableTd,
    GridTableTh,
    Grid,
    WhatyDialog
  },
  name: 'app-task-record',
  data() {
    return {
      gridConfigUrl: '',
      dialogVisible: false,
      content: '',
      detailTitle: '',
      operationTip: '查看详情'
    }
  },
  created() {
    this.gridConfigUrl = this.$route.meta.url
  },
  methods: {
    operation(data) {
      const status = data.sendState
      if (status === '发送完毕') {
        // 更新发送的统计数据
        const params = {
          params: {
            taskId: data.id
          }
        }
        util.ajax.post('/entity/notification/appTaskRecord/update', params).then(res => {
          if (res.data.meta.errCode === 0) {
            let msg = res.data.meta.errMsg || '操作成功！'
            this.$notify.success({title: '成功', message: msg === 'ok' ? '操作成功' : msg})
            this.$refs.myGrid.loadTableData()
          } else {
            this.$notify.warning({title: '警告', message: res.data.meta.errMsg || '操作失败！'})
          }
        }).catch(err => {
          console.log(err)
          this.$notify.error({title: '错误', message: '操作失败！'})
        })
      } else {
        // 查看详情
        let text = ''
        if (status === '发送失败') {
          text = `失败原因：<span style="color: red;">${data.errMsg}</span>`
        } else {
          this.$notify.warning({title: '警告', message: '消息未发送，无法获取数据'})
          return
        }
        this.showAppErrorMsg(status, text)
      }
    },
    handle(data) {
      const contentObj = JSON.parse(data.content)
      const notification = contentObj.notification
      if (notification) {
        const platform = data.targetPlatform
        let content = ''
        if (platform.includes('android') || platform.includes('all')) {
          if (notification.android && notification.android.alert) {
            if (notification.android.title) {
              content += `<div style="padding: 2px;"><div><b>Android：</b></div><div style="padding-top: 4px;padding-bottom: 4px;">${notification.android.title}</div><div style="padding-top: 4px;padding-bottom: 4px;">${notification.android.alert}</div></div>`
            } else {
              content += `<div style="padding: 2px;line-height: 1.5;"><b>Android：<br></b>${notification.android.alert}</div>`
            }
          } else if (notification.alert) {
            content += `<div style="padding: 2px;line-height: 1.5;"><b>Android：<br></b>${notification.alert}</div>`
          }
        }
        if (platform.includes('ios') || platform.includes('all')) {
          if (notification.ios && notification.ios.alert) {
            content += `<div style="padding: 2px;line-height: 1.5;"><b>iOS：<br></b>${notification.ios.alert}</div>`
          } else if (notification.alert) {
            content += `<div style="padding: 2px;line-height: 1.5;"><b>iOS：<br></b>${notification.alert}</div>`
          }
        }
        if (platform.includes('quickapp') || platform.includes('all')) {
          if (notification.quickapp && notification.quickapp.alert) {
            if (notification.quickapp.title) {
              content += `<div style="padding: 2px;"><div><b>QuickApp：</b></div><div style="padding-top: 4px;padding-bottom: 4px;">${notification.quickapp.title}</div><div style="padding-top: 4px;padding-bottom: 4px;">${notification.quickapp.alert}</div></div>`
            } else {
              content += `<div style="padding: 2px;line-height: 1.5;"><b>QuickApp：<br></b>${notification.quickapp.alert}</div>`
            }
          } else if (notification.alert) {
            content += `<div style="padding: 2px;line-height: 1.5;"><b>QuickApp：<br></b>${notification.alert}</div>`
          }
        }
        if (platform.includes('winphone') || platform.includes('all')) {
          if (notification.winphone && notification.winphone.alert) {
            if (notification.winphone.title) {
              content += `<div style="padding: 2px;line-height: 1.5;"><div><b>Windows Phone：</b></div><div style="padding-top: 4px;padding-bottom: 4px;">${notification.winphone.title}</div><div style="padding-top: 4px;padding-bottom: 4px;">${notification.winphone.alert}</div></div>`
            } else {
              content += `<div style="padding: 2px;line-height: 1.5;"><b>Windows Phone：<br></b>${notification.winphone.alert}</div>`
            }
          } else if (notification.alert) {
            content += `<div style="padding: 2px;"><b>Windows Phone：<br></b>${notification.alert}</div>`
          }
        }
        this.showAppDetail('APP推送内容', content || `<div style="color: red;"><i>不能提取发送内容</i></div>`)
      } else {
        this.showAppDetail('APP推送内容', `<div style="color: red;"><i>不能提取发送内容</i></div>`)
      }
      // let arContent = ''
      // let iosContent = ''
      // let quickContent = ''
      // let winPhoneContent = ''
      // if (data.targetPlatform === 'all') {
      //
      //
      //   if (notification.ios && notification.ios.alert) {
      //     iosContent = `<div><b>iOS：</b>${notification.ios.alert}</div>`
      //   } else {
      //     iosContent = `<div><b>iOS：</b>${notification.alert}</div>`
      //   }
      //
      //   if (notification.quickapp && notification.quickapp.alert) {
      //     quickContent = `<div><b>QuickAPP：</b>${notification.quickapp.alert}</div>`
      //   } else {
      //     quickContent = `<div><b>QuickAPP：</b>${notification.alert}</div>`
      //   }
      //
      //   if (notification.winphone && notification.winphone.alert) {
      //     winPhoneContent = `<div><b>Windows Phone：</b>${notification.winphone.alert}</div>`
      //   } else {
      //     winPhoneContent = `<div><b>Windows Phone：</b>${notification.alert}</div>`
      //   }
      //
      //   this.showAppDetail('APP推送内容', arContent + iosContent + quickContent + winPhoneContent)
      //   return
      // }
    },
    showAppDetail(detailTitle, pushContent) {
      this.detailTitle = detailTitle
      this.dialogVisible = true
      this.content = pushContent
    },
    showAppErrorMsg(title, pushContent) {
      this.$msgBox.showMsgBox({
        title: title,
        content: pushContent,
        isShowCancelBtn: false
      }).catch(() => {
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/custom/components/grid/notification/app-task-record.vue